export default __webpack_public_path__ + "static/2-5201be430adbd5d71a536c2746d70876.svg";